import Client from 'evcharging/app/http/Client';

export const httpClient = () => new Client();
